module.exports = __webpack_public_path__ + "static/pic03-74fa7145645d520d9e8664277e7ceaed.jpg";